import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { URLS, Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { Groups, Props as WidgetProps } from './Groups';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import EmptyState from '../../EmptyState';
import GroupsConfigPopover from './GroupsConfigPopover';

import s from './Groups.scss';

class GroupsBox extends React.Component<
  WidgetProps &
    WidgetBoxProps &
    WithTranslation & {
      totalCount?: number;
      isOwner: boolean;
      isEmpty: boolean;
    }
> {
  render() {
    const {
      hasMore,
      totalCount,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isEmpty,
      section,
      zone,
      ...props
    } = this.props;
    const { t, type, moduleId, profileOwnerUser, isOwner } = props;
    const seeAllFragment =
      props.type === 'member' ? 'group_list_members' : 'group_list_admins';

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t(`widgets.groups_${type}.header`)}
        count={totalCount}
        seeAllUrl={Url.userLink(
          profileOwnerUser.username,
          `${USER_PROFILE_SECTION_PATHS.ABOUT}#${seeAllFragment}`
        )}
        hasMore={hasMore}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        widgetMenuRenderer={close => (
          <GroupsConfigPopover moduleId={moduleId} onClose={close} />
        )}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={classnames(s['empty-state'], s['is-owner'], s[type])}
              title={t(`widgets.groups_${type}.empty.title.owner`)}
              subtitle={t(`widgets.groups_${type}.empty.subtitle.owner`)}
              buttonLabel={t(`widgets.groups_${type}.empty.CTALabel.owner`)}
              withButton={true}
              onButtonClick={this.navigateToBrowseGroups}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              titleClassName={'empty-state-title'}
              title={t(`widgets.groups_${type}.empty.title.visitor`, {
                username: profileOwnerUser.username,
              })}
              subtitle={t(`widgets.groups_${type}.empty.subtitle.visitor`, {
                username: profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <Groups {...props} />
      </WidgetBox>
    );
  }

  navigateToBrowseGroups() {
    window.location.replace(URLS.GROUPS);
  }
}

export default withTranslation()(GroupsBox) as React.ComponentType<{}>;
